import React, { useEffect, useRef, useState, useMemo } from "react"
import { motion } from "framer-motion"
import { Heading, Text, Box } from "theme-ui"

// Word wrapper
const Wrapper = props => {
  // We'll do this to prevent wrapping of words using CSS
  return <span className="word-wrapper">{props.children}</span>
}

// Map API "type" vaules to JSX tag names
const tagMap = {
  heading: Heading,
  text: Text,
  box: Box,
}

// AnimatedCharacters
// Handles the deconstruction of each word and character to setup for the
// individual character animations
const SlideInComponent = props => {
  const [isIntersecting, setIsIntersecting] = useState(false)
  const [splitWords, setSplitWords] = useState()
  const [words, setWords] = useState()
  const [isInViewport, setIsInViewport] = useState(false)
  const refText = useRef()

  // Framer Motion variant object, for controlling animation
  const container = {
    hidden: {
      y: "100%",
      opacity: 0,
      transition: { ease: [0.455, 0.03, 0.515, 0.955], duration: 0.6 },
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: { ease: [0.455, 0.03, 0.515, 0.955], duration: 0.6 },
    },
  }

  useEffect(() => {
    const ioOptions = {
      threshold: 0.5,
    }
    const ioCallback = (entries, observer) => {
      const entry = entries[0]
      if (entry.isIntersecting) {
        setIsInViewport(true)
      }
    }

    const observer = new IntersectionObserver(ioCallback, ioOptions)
    observer.observe(refText.current)
  }, [])

  return (
    <Box sx={{ ...props.sx }} ref={refText}>
      <motion.div
        initial="hidden"
        animate={isInViewport ? "visible" : "hidden"}
        variants={container}
      >
        {props.children}
      </motion.div>
    </Box>
  )
}

export default SlideInComponent
